import { useContext, useState } from 'react'
import { Flex, Form, Typography, Upload } from 'antd'
import { CheckCircleOutlined, UploadOutlined } from '@ant-design/icons'
import { postRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { useIntl } from 'react-intl'

const DefForm = (props) => {
  const { vehicle } = useParams()
  const intl = useIntl()
  const [, dispatch] = useContext(NavContext)
  const [form] = Form.useForm()
  const [uploaded, setUploaded] = useState(false)

  const submitDefFile = async (values) => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'defPlugin.uploadingCaption' }),
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData()
    if (values.plugin_view?.[0]) {
      formData.append(
        'plugin_view',
        values.plugin_view[0].originFileObj || values.plugin_view[0]
      )
    }
    if (values.supp_file?.[0]) {
      formData.append(
        'supp_file',
        values.supp_file[0].originFileObj || values.supp_file[0]
      )
    }
    formData.append('file_id', values.file_id)
    formData.append('description', values.description)
    formData.append('abbreviation', values.abbreviation)
    formData.append('vehicle', vehicle)

    let res = await postRequest(
      `/api/plugin/def/upload_def/${vehicle}/`,
      formData,
      false,
      {
        onUploadProgress: (progressEvent) => {
          const totalLength = progressEvent.lengthComputable
            ? progressEvent.total
            : progressEvent.target.getResponseHeader('content-length') ||
              progressEvent.target.getResponseHeader(
                'x-decompressed-content-length'
              )
          const percentageCompleted = Math.round(
            (progressEvent.loaded * 100) / totalLength
          )
          if (percentageCompleted === 100) {
            dispatch({ type: 'loader', data: {}, notification: {} })
          }
        },
      }
    )
    dispatch({ type: 'loader', data: {}, notification: {} })

    if (res?.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({ id: 'defPlugin.uploadSuccess' }),
        },
      })
      setUploaded(true)
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'defPlugin.uploadError' }),
        },
      })
    }
  }

  if (uploaded) {
    return (
      <Flex
        align="center"
        justify="center"
        vertical
        gap={12}
        style={{ padding: 40 }}
      >
        <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a' }} />
        <Typography.Text strong style={{ fontSize: 20 }}>
          {intl.formatMessage({ id: 'defPlugin.uploadSuccessTitle' })}
        </Typography.Text>
        <Typography.Text type="secondary">
          {intl.formatMessage({ id: 'defPlugin.uploadSuccessNote' })}
        </Typography.Text>
      </Flex>
    )
  }

  return (
    <Form form={form} layout="vertical" onFinish={submitDefFile}>
      <Flex vertical gap={16}>
        <Flex gap={16} className="full-width">
          <InputText
            name="file_id"
            label={intl.formatMessage({ id: 'defPlugin.fileId' })}
            isRequired={true}
            wrapperClass="def-file-id"
          />

          <InputText
            name="abbreviation"
            label={intl.formatMessage({ id: 'defPlugin.abbreviation' })}
            isRequired={false}
            maxLength={6}
          />
        </Flex>

        <InputText
          name="description"
          label={intl.formatMessage({ id: 'defPlugin.description' })}
          isRequired={true}
        />

        <Form.Item
          name="plugin_view"
          label={intl.formatMessage({ id: 'defPlugin.defFile' })}
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList || []}
          rules={[{ required: true }]}
          help={false}
          style={{ marginBottom: 0 }}
        >
          <Upload beforeUpload={() => false} maxCount={1} accept=".def">
            <Button icon={<UploadOutlined />}>
              {intl.formatMessage({ id: 'defPlugin.chooseDefFile' })}
            </Button>
          </Upload>
        </Form.Item>

        <Form.Item
          name="supp_file"
          label={intl.formatMessage({ id: 'defPlugin.suppFile' })}
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList || []}
          style={{ marginBottom: 0 }}
        >
          <Upload beforeUpload={() => false} maxCount={1}>
            <Button icon={<UploadOutlined />}>
              {intl.formatMessage({ id: 'defPlugin.chooseSuppFile' })}
            </Button>
          </Upload>
        </Form.Item>

        <Flex justify="end">
          <Button type="primary" htmlType="submit">
            {intl.formatMessage({ id: 'forms.save' })}
          </Button>
        </Flex>
      </Flex>
    </Form>
  )
}

export default DefForm
